import React from 'react';
import { useTranslation } from 'react-i18next';
import { EosCalculationStep } from '../../../../../models/payroll';
import { formatNumber } from '../../../../../utils';

interface Props {
  steps: EosCalculationStep[];
  finalGratuity: number;
  currencySymbol?: string;
}

export const EosBreakdownTable: React.FC<Props> = ({ steps, finalGratuity, currencySymbol = '' }) => {
  const { t } = useTranslation('common');

  return (
    <div className="rounded-xl border border-border overflow-hidden">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-muted text-muted-foreground">
            <th className="px-3 py-2 text-start font-medium">#</th>
            <th className="px-3 py-2 text-start font-medium">{t('Step')}</th>
            <th className="px-3 py-2 text-start font-medium hidden md:table-cell">{t('Formula')}</th>
            <th className="px-3 py-2 text-end font-medium">{t('Result')}</th>
            <th className="px-3 py-2 text-start font-medium hidden lg:table-cell">{t('Law')}</th>
          </tr>
        </thead>
        <tbody>
          {steps.map((step) => (
            <tr key={step.stepNumber} className="border-t border-border hover:bg-muted/30 transition-colors">
              <td className="px-3 py-2 text-muted-foreground">{step.stepNumber}</td>
              <td className="px-3 py-2 text-foreground">{step.description}</td>
              <td className="px-3 py-2 text-muted-foreground hidden md:table-cell font-mono text-xs">{step.formula}</td>
              <td className="px-3 py-2 text-end font-semibold text-foreground">{step.result}</td>
              <td className="px-3 py-2 text-xs text-muted-foreground hidden lg:table-cell">{step.lawCitation}</td>
            </tr>
          ))}
          <tr className="border-t-2 border-primary/30 bg-primary/5">
            <td colSpan={2} className="px-3 py-2 font-semibold text-foreground">{t('Final Gratuity')}</td>
            <td className="px-3 py-2 hidden md:table-cell" />
            <td className="px-3 py-2 text-end font-bold text-primary text-base">
              {formatNumber(finalGratuity)} {currencySymbol}
            </td>
            <td className="px-3 py-2 hidden lg:table-cell" />
          </tr>
        </tbody>
      </table>
    </div>
  );
};
